import { type FunctionComponent } from "react";

import prioSoftLogo from "images/Common/PrioSoft_Logo.png";

import { type IBTIconProps } from "../BTIcon.types";

export const BTIconDeprecatedPrioSoft: FunctionComponent<IBTIconProps> = (baseProps) => {
    return (
        <img alt="" src={prioSoftLogo} style={baseProps.style} className={baseProps.className} />
    );
};
